/**
 * Standardizes queries to a simple string
 *
 * @param query the query argument that more than likely will just be a string, but could be an array
 */
export const stringifyQuery: (
  query?: string | string[] | number | number[],
) => string = (query) =>
  (query && (Array.isArray(query) ? query.join('') : `${query}`)) || '';
